const cs = {
    '/': {
        title: '{brand} | Sportovní Sázení, Live Casino & Okamžité Výběry',
        description: 'Automaty, live casino & sportovní sázení u {brand}. Krypto casino s okamžitými výběry, prokazatelně férovými hrami & podporou 24/7.'
    },
    '/casino': {
        title: 'Online Casino | Automaty, Blackjack & Live Dealeři | {brand}',
        description: 'Automaty, blackjack, ruleta & live dealeři u {brand}. Stovky her, rychlé krypto vklady & okamžité výběry dostupné 24/7.'
    },
    '/sports': {
        title: 'Online Sportovní Sázení | Krypto Sázky & Kurzy | {brand}',
        description: 'Sázejte na sport u {brand}. Konkurenční kurzy na fotbal, basketbal & další. Live sázení, bezpečné krypto sázky & rychlé výplaty.'
    },
    '/livecasino': {
        title: 'Live Casino | Blackjack, Ruleta & Live Dealeři | {brand}',
        description: 'Blackjack, ruleta & live casino hry u {brand}. Praví dealeři, HD streaming & široký výběr live stolů dostupných 24/7.'
    },
    '/slots': {
        title: 'Online Automaty | Velký Výběr Casino Slotů | {brand}',
        description: 'Obrovská sbírka automatů u {brand}. Klasické ovocné automaty, video sloty & progresivní jackpoty – vše hratelné s kryptem.'
    }
};
export default cs;
